import React from "react";
import { invitationStatusStyle } from "./supplierManagementHelpers";

const InvitationStatusBadge = ({ statusKey }) => {
  const badge = invitationStatusStyle(statusKey);
  return (
    <span
      style={{
        display: "inline-block",
        padding: "3px 10px",
        borderRadius: 999,
        fontSize: 11,
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.05em",
        fontFamily: "var(--font-mono)",
        background: badge.bg,
        color: badge.color,
        border: `1px solid ${badge.border}`,
      }}
    >
      {statusKey || "—"}
    </span>
  );
};

export default InvitationStatusBadge;
